import {downloadFile} from '@domain/file-download'
import {spawnErrorToast} from '@hm/fundamental'
import {useMutation} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {downloadSectionSubmissions} from '../../common/backend/sections'
import {FEATURE_NAMESPACE} from '../../consts'

export const useSectionSubmissionsDownload = (plantId: string, sectionId: string) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return useMutation({
    mutationFn: () => downloadSectionSubmissions({plantId, sectionId}),
    onSuccess: (blob: Blob) => {
      downloadFile(blob, `${plantId}_${sectionId}_submissions.xlsx`)
    },
    onError: () => {
      spawnErrorToast(t('errors.excelDownloadFailed'))
    }
  })
}
